export const apiUrl = "https://generic-api.alink.digital"
